import { ButtonLink } from "@/components/ui/button";
import S from "./index.module.scss";
import { useEffect } from "react";
import CustomIcon from "@/components/ui/custom-icon";
import { useTranslations } from "next-intl";

const Sidebar = () => {
  const t = useTranslations();

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div className={S.wrapper}>
      <div className={S.nav}>
        <ButtonLink href="/about">{t("header.about")}</ButtonLink>
        <ButtonLink href="/production">{t("header.production")}</ButtonLink>
        <ButtonLink href="/vacancy">{t("header.vacancies")}</ButtonLink>
        <ButtonLink href="/academy">{t("header.academy")}</ButtonLink>
        <ButtonLink href="/culture">{t("header.corporateCulture")}</ButtonLink>
      </div>
      <div className={S.contacts}>
        <p className={S.contactsTitle}>{t("footer.hotline")}</p>
        <a href="tel:+78002002929" className={S.contactsPhone}>
          8 800 200-29-29
        </a>
        <a href="mailto:info@aquaart.ru" className={S.contactsEmail}>
          info@aquaart.ru
        </a>
        <a href="https://vk.com/aquaart_group" rel="noreferrer" target="_blank" className={S.iconLink}>
          <CustomIcon fileName="icon-vk" />
        </a>
      </div>
    </div>
  );
};

export default Sidebar;
